import { CellContext } from '@tanstack/react-table';
import React, { FunctionComponent } from 'react';

import { EVENT_CODE } from '@savgroup-front-common/constants';
import { ShortcutKeyboard } from '@savgroup-front-common/core/molecules/ShortcutKeyboard';

import { ShortcutKey } from '../../../ShortcutsContent.types';
import { $ShortcutKeyGroup } from '../../../ShortcutsModal.styles';

const ShortcutCell: FunctionComponent<
  React.PropsWithChildren<CellContext<ShortcutKey, EVENT_CODE[]>>
> = ({ getValue }) => {
  const value = getValue();

  return (
    <$ShortcutKeyGroup>
      {value.map((code, index) => {
        return (
          <React.Fragment key={code}>
            {index > 0 && '+'}
            <ShortcutKeyboard code={code} />
          </React.Fragment>
        );
      })}
    </$ShortcutKeyGroup>
  );
};

ShortcutCell.displayName = 'ShortcutCell';

export default ShortcutCell;
